import { useState } from 'react';

export default function Settings() {
  const [apiKey, setApiKey] = useState('');
  const [widgetEnabled, setWidgetEnabled] = useState(true);
  const [language, setLanguage] = useState('en');

  const handleSave = () => {
    // TODO: Save settings via API
    alert('Settings saved!');
  };

  return (
    <div className="px-4 py-6 sm:px-0">
      <h2 className="text-2xl font-semibold text-gray-900 mb-6">Settings</h2>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <div className="space-y-6">
            <div>
              <label htmlFor="api-key" className="block text-sm font-medium text-gray-700">
                API Key
              </label>
              <input
                type="text"
                id="api-key"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                placeholder="sk-..."
              />
              <p className="mt-2 text-sm text-gray-500">
                Your API key for integrating BuyChatly with your store.
              </p>
            </div>

            <div className="flex items-center">
              <input
                id="widget-enabled"
                type="checkbox"
                checked={widgetEnabled}
                onChange={(e) => setWidgetEnabled(e.target.checked)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="widget-enabled" className="ml-2 block text-sm text-gray-900">
                Enable widget on storefront
              </label>
            </div>

            <div>
              <label htmlFor="language" className="block text-sm font-medium text-gray-700">
                Default Language
              </label>
              <select
                id="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              >
                <option value="en">English</option>
                <option value="pl">Polish</option>
                <option value="de">German</option>
                <option value="es">Spanish</option>
                <option value="fr">French</option>
              </select>
            </div>

            <div className="pt-5">
              <button
                onClick={handleSave}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Save Settings
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Installation Instructions
          </h3>
          <div className="bg-gray-50 rounded-md p-4">
            <code className="text-sm text-gray-900">
              {`<!-- Add to your website -->
<script src="https://cdn.buychatly.com/widget.js"></script>
<script>
  BuyChatly.init({
    apiKey: '${apiKey || 'YOUR_API_KEY'}',
    language: '${language}'
  });
</script>`}
            </code>
          </div>
        </div>
      </div>
    </div>
  );
}
